import { RouteDetail, RouteDetails } from "~/application/types";
import { RouteDetailDTO, RouteDetailsDTO } from "../dtos";
import { mapMapAddressDTO } from "./mapMapAddressDTO";

export function mapRouteDetailDTO(data: RouteDetailDTO): RouteDetail {
  return {
    from: mapMapAddressDTO(data.from),
    to: mapMapAddressDTO(data.to),
    polyline: data.polyline,
    distanceInMeters: data.distance.meters,
    durationInSeconds: data.duration.seconds,
    totalValueInBRL: data.total_value?.brl || 0,
  };
}

export function mapRouteDetailsDTO(data: RouteDetailsDTO): RouteDetails {
  return {
    routes: data.routes.map(mapRouteDetailDTO),
    distanceInMeters: data.distance.meters,
    durationInSeconds: data.duration.seconds,
    totalValueInBRL: data.total_value.brl,
  };
}
